import { render, staticRenderFns } from "./ShowImageInCard.vue?vue&type=template&id=e5fe3dc4&scoped=true"
import script from "./ShowImageInCard.vue?vue&type=script&lang=js"
export * from "./ShowImageInCard.vue?vue&type=script&lang=js"
import style0 from "./ShowImageInCard.vue?vue&type=style&index=0&id=e5fe3dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fe3dc4",
  null
  
)

export default component.exports